import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export const AboutCountryUsa = () => {
  const navigate = useNavigate();

  const usaData = {
    title: "Study Abroad Opportunities USA",
    mTitle: "Why Study in the USA?",
    desc_1:
      "The United States stands as a global leader in higher education, offering an unparalleled diversity of academic programs and institutions. With its cutting-edge research facilities, innovative teaching methods, and strong support for international students, studying in the USA opens doors to global opportunities.",
    desc_2:
      "In the USA, you’ll find not only academic excellence but also a diverse cultural environment, internships, and strong industry ties. It’s more than education—it’s a life experience.",
  };

  const usaBenefits = [
    { title: "World-Class Education", number: 550, suffix: "+" },
    { title: "Diverse Academic Programs", number: 100, suffix: "%" },
    { title: "Top-Ranked Universities", number: 300, suffix: "+" },
    { title: "Strong Industry Connections", number: 550, suffix: "+" },
  ];

  const usaUniversities = [
  { title: "Adelphi University", img: "/image/study-abroad/usa/adelphi-university.png", link: "#" },
  { title: "American Collegiate", img: "/image/study-abroad/usa/american-collegiate.png", link: "#" },
  { title: "American University", img: "/image/study-abroad/usa/american-university.png", link: "#" },
  { title: "Auburn University at Montgomery", img: "/image/study-abroad/usa/auburn-university-at-montgomery.png", link: "#" },
  { title: "Avila University", img: "/image/study-abroad/usa/avila-university.png", link: "#" },
  { title: "Auburn University", img: "/image/study-abroad/usa/auburn-university.png", link: "#" },
  { title: "California State University, Monterey Bay", img: "/image/study-abroad/usa/california-state-university-monterey.png", link: "#" },
  { title: "Concordia University, St. Paul", img: "/image/study-abroad/usa/concordia-university-st-paul.png", link: "#" },
  { title: "DePaul University", img: "/image/study-abroad/usa/depaul-university.png", link: "#" },
  { title: "Florida International University (FIU)", img: "/image/study-abroad/usa/fiu.png", link: "#" },
  { title: "Foothill + De Anza Colleges", img: "/image/study-abroad/usa/foothill-deanza.png", link: "#" },
  { title: "Full Sail University", img: "/image/study-abroad/usa/full-sail-university.png", link: "#" },
  { title: "Hawai‘i Pacific University", img: "/image/study-abroad/usa/hawai-pacific-university.png", link: "#" },
  { title: "Long Island University Brooklyn", img: "/image/study-abroad/usa/long-island-university-brooklyn.png", link: "#" },
  { title: "Louisiana State University", img: "/image/study-abroad/usa/louisiana-state-university.png", link: "#" },
  { title: "Rowan University", img: "/image/study-abroad/usa/rowan-university.png", link: "#" },
  { title: "Texas A&M University–Corpus Christi (TAMUCC)", img: "/image/study-abroad/usa/tamucc.jpg", link: "#" },
  { title: "Tiffin University", img: "/image/study-abroad/usa/tiffin-university.png", link: "#" },
  { title: "University of Alabama at Birmingham (UAB)", img: "/image/study-abroad/usa/uab.png", link: "#" },
  { title: "University of Central Florida (UCF)", img: "/image/study-abroad/usa/ucf.png", link: "#" },
  { title: "University of Kansas", img: "/image/study-abroad/usa/university-of-kansas.png", link: "#" },
  { title: "University of Dayton", img: "/image/study-abroad/usa/university-of-dayton.png", link: "#" },
  { title: "University of Hartford", img: "/image/study-abroad/usa/university-of-hartford.png", link: "#" },
  { title: "University of Massachusetts Boston", img: "/image/study-abroad/usa/university-of-massachusetts-boston.png", link: "#" },
  { title: "University of Mississippi", img: "/image/study-abroad/usa/university-of-mississippi.png", link: "#" },
  { title: "University of South Carolina", img: "/image/study-abroad/usa/university-of-south-carolina.png", link: "#" },
  { title: "University of the Pacific", img: "/image/study-abroad/usa/university-of-the-pacific.png", link: "#" },
  { title: "University of Utah", img: "/image/study-abroad/usa/university-of-utah.png", link: "#" },
];



  const responsiveCarousel = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
    tablet: { breakpoint: { max: 1024, min: 600 }, items: 2 },
    mobile: { breakpoint: { max: 600, min: 0 }, items: 1 },
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
        <style>
        {`
          .react-multiple-carousel__arrow {
            margin-left: -45px;
            margin-right: -45px;
          }
          
        `}
      </style>

      {/* Hero Section */}
      <section className="mb-12">
        <h1 className="text-4xl font-bold text-indigo-700 mb-6">
          {usaData.title}
        </h1>

        {/* Carousel After Main Title */}
        <div className="mb-10 mt-10">
<h3 className="text-2xl font-semibold text-indigo-600 mb-5 mt-5">Top Universities in the USA</h3>
        <p className="text-gray-600 mb-6 mt-5">Explore Our Partner Institutions</p>

             <Carousel
            responsive={responsiveCarousel}
            infinite
            autoPlay
            autoPlaySpeed={4000}
            arrows
            keyBoardControl
            showDots={false}
            containerClass="carousel-container-custom"
            itemClass="px-3"
            renderButtonGroupOutside={false}
          >
            {usaUniversities.map((univ, idx) => {
              const content = (
                <div className="bg-white rounded-lg mt-10 shadow hover:shadow-lg transition-all duration-300 p-4 text-center h-full flex flex-col items-center justify-between">
                  <img
                    src={univ.img}
                    alt={univ.title}
                    className="rounded-md max-h-36 w-full object-contain mb-3"
                    loading="lazy"
                  />
                  <h5 className="text-sm font-medium text-gray-700">{univ.title}</h5>
                </div>
              );
              return univ.link ? (
                <Link key={idx} to={univ.link}>
                  {content}
                </Link>
              ) : (
                <div key={idx}>{content}</div>
              );
            })}
          </Carousel>

        </div>

        {/* Rest of the Section */}
        <h2 className="text-2xl text-indigo-600 font-semibold mb-4">{usaData.mTitle}</h2>
        <p className="text-gray-700 mb-3 leading-relaxed">{usaData.desc_1}</p>
        <p className="text-gray-700 leading-relaxed">{usaData.desc_2}</p>
        <img
          src="/image/about/about-07/usa.png"
          alt="Study in USA"
          className="w-[30%] h-[30%] mx-auto mt-6 rounded-lg object-cover shadow"
        />
      </section>

      {/* Features Section */}
      <section className="mb-16">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">Key Benefits of Studying in the USA</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {usaBenefits.map((item, idx) => (
            <div key={idx} className="bg-white p-6 rounded-xl shadow-md text-center border border-gray-100">
              <div className="text-3xl font-bold text-indigo-600">
                {item.number}
                {item.suffix}
              </div>
              <p className="mt-2 text-lg font-medium text-gray-700">{item.title}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <div className="text-center mt-12">
        <button
          onClick={() => navigate("/contact-us")}
          className="bg-indigo-600 text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-indigo-700 transition"
        >
          Apply Now!
        </button>
      </div>
    </div>
  );
};

export default AboutCountryUsa;
